module.exports = __webpack_public_path__ + "img/图片2.64622440.png";